import SegmentSnippet from '@utils/segment/SegmentSnippet';

declare global {
  interface Window {
    analytics: any;
  }
}

export const initialiseAnalytics = () => {
  SegmentSnippet();
};

/*
 * Track any page change
 */
export const TrackPage = () => {
  const url = window.location.pathname;
  window.analytics?.page({
    url,
  });
};

export interface TrackEventProps {
  event: string; // description of action  e.g. 'Search actions'
  properties: {
    category: string; // Event group / app section, e.g.'Account'
    label?: string; // Specific identifier, e.g. 'toe/bucketName'
    value?: number; // a value associated with an action - eg, number of search results
    [key: string]: string | number | undefined; // other properties, undefined only to suffice the optional props above
  };
}

/*
 * Track any user event
 * @param event Specific event that happened
 * @param properties
 */
export const TrackEvent = ({ event, properties }: TrackEventProps) => {
  window.analytics?.track(event, properties);
};
